"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHaveClass = toHaveClass;

var _utils = require("./utils");

function getExpectedClassNamesAndOptions(params) {
  var lastParam = params.pop();
  var expectedClassNames, options;

  if (typeof lastParam === 'object') {
    expectedClassNames = params;
    options = lastParam;
  } else {
    expectedClassNames = params.concat(lastParam);
    options = {
      exact: false
    };
  }

  return {
    expectedClassNames: expectedClassNames,
    options: options
  };
}

function splitClassNames(str) {
  if (!str) {
    return [];
  }

  return str.split(/\s+/).filter(function (s) {
    return s.length > 0;
  });
}

function isSubset(subset, superset) {
  return subset.every(function (item) {
    return superset.includes(item);
  });
}

function toHaveClass(htmlElement) {
  var _this = this;

  (0, _utils.checkHtmlElement)(htmlElement, toHaveClass, this);

  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  var _getExpectedClassName = getExpectedClassNamesAndOptions(params),
      expectedClassNames = _getExpectedClassName.expectedClassNames,
      options = _getExpectedClassName.options;

  var received = splitClassNames(htmlElement.getAttribute('class'));
  var expected = expectedClassNames.reduce(function (acc, className) {
    return acc.concat(splitClassNames(className));
  }, []);

  if (options.exact) {
    return {
      pass: isSubset(expected, received) && expected.length === received.length,
      message: function message() {
        var to = _this.isNot ? 'not to' : 'to';
        return (0, _utils.getMessage)(_this, _this.utils.matcherHint("".concat(_this.isNot ? '.not' : '', ".toHaveClass"), 'element', _this.utils.printExpected(expected.join(' '))), "Expected the element ".concat(to, " have EXACTLY defined classes"), expected.join(' '), 'Received', received.join(' '));
      }
    };
  }

  return expected.length > 0 ? {
    pass: isSubset(expected, received),
    message: function message() {
      var to = _this.isNot ? 'not to' : 'to';
      return (0, _utils.getMessage)(_this, _this.utils.matcherHint("".concat(_this.isNot ? '.not' : '', ".toHaveClass"), 'element', _this.utils.printExpected(expected.join(' '))), "Expected the element ".concat(to, " have class"), expected.join(' '), 'Received', received.join(' '));
    }
  } : {
    pass: this.isNot ? received.length > 0 : false,
    message: function message() {
      return _this.isNot ? (0, _utils.getMessage)(_this, _this.utils.matcherHint('.not.toHaveClass', 'element', ''), 'Expected the element to have classes', '(none)', 'Received', received.join(' ')) : [_this.utils.matcherHint(".toHaveClass", 'element'), 'At least one expected class must be provided.'].join('\n');
    }
  };
}